import { ChevronRight, ExternalLink, Play } from "lucide-react"
import type { ResourceLink } from "@/entities/beginner-path"
import { HapticLink } from "@/shared/ui/haptic-link"

const ROW =
	"flex min-h-12 w-full items-center gap-3 rounded-xl px-2 py-2 text-left transition-colors active:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"

export function ResourceRow({
	label,
	url,
	resolvedPostId,
}: ResourceLink & { resolvedPostId?: string }) {
	const body = (
		<>
			<span className="grid size-9 shrink-0 place-items-center rounded-xl bg-primary/15 text-primary">
				{resolvedPostId ? (
					<Play className="size-4 fill-current" />
				) : (
					<ExternalLink className="size-4" />
				)}
			</span>
			<span className="min-w-0 flex-1 text-sm leading-snug">{label}</span>
			<ChevronRight className="size-4 shrink-0 text-muted-foreground" />
		</>
	)

	if (resolvedPostId) {
		return (
			<HapticLink to={`/post/${resolvedPostId}`} className={ROW}>
				{body}
			</HapticLink>
		)
	}

	return (
		<a href={url} target="_blank" rel="noreferrer" className={ROW}>
			{body}
		</a>
	)
}
